import { DatabaseRecordType } from "../enums";
import { IModifyUser } from "../user/modifyUser";

export interface ILockedRecord {
    companyId: string;
    id: string;
    userCode: string;
    recordType: DatabaseRecordType;
}

export class LockedRecord implements ILockedRecord {
    companyId: string;
    id: string;
    userCode: string;
    recordType: DatabaseRecordType;

    constructor();
    constructor(obj: ILockedRecord);
    constructor(obj?: any) {
        this.companyId = obj && obj.companyId || "";
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.recordType = obj && obj.recordType || DatabaseRecordType.Message;
    }

    static isLockedToUser(lockedUser: IModifyUser, userCode: string): boolean {
        return lockedUser?.code && userCode.equalIgnoreCase(lockedUser.code);
    }

    static createLockedRecord(companyId: string, id: string, userCode: string, recordType: DatabaseRecordType): ILockedRecord {
        const result = new LockedRecord();
        result.companyId = companyId;
        result.id = id;
        result.userCode = userCode;
        result.recordType = recordType;
        return result;
    }
}